import { useEffect } from 'react';
// mantine
import { ScrollArea } from '@mantine/core';
// components
import type { IAct } from '@newo/api/gateway';
import ActsHistory from '@/modules/Chat/components/ActsHistory';
import AgentMessage from '@/modules/Chat/components/AgentMessage';
import UserMessage from '@/modules/Chat/components/UserMessage';
// utils
import useViewport from '@/utils/hooks/useViewport.ts';
import * as types from '@/modules/Chat/Chat.types';
// assets
import styles from '@/modules/Sandbox/components/Content/Content.module.css';

interface ContentProps {
    messages: types.IChatMessage[];
    acts: IAct[];
}

const Content = ({ messages, acts }: ContentProps) => {
    const { viewport, scrollToBottom } = useViewport();
    useEffect(() => {
        scrollToBottom();
    }, [messages, scrollToBottom]);

    return (
        <ScrollArea h="100%" scrollbars="y" type="hover" viewportRef={viewport}>
            <div className={styles.content}>
                <ActsHistory acts={acts} />
                {messages.map((message) =>
                    message.is_agent ? (
                        <AgentMessage
                            content={message.content}
                            datetime={message.datetime}
                            key={message.stream_id}
                        />
                    ) : (
                        <UserMessage
                            content={message.content}
                            datetime={message.datetime}
                            key={message.datetime}
                        />
                    )
                )}
            </div>
        </ScrollArea>
    );
};

export default Content;
